// extracted by mini-css-extract-plugin
export default {"infoCard":"infoCard_infoCard__TXKm2","infoCard__icon":"infoCard_infoCard__icon__U9S6n","infoCard__text":"infoCard_infoCard__text__s38XS"};